import { WalletResourceResponse } from '@/modules/allies/allies/services/apiValidationSchemas.ts'

export const currencyPaymentBank: WalletResourceResponse = [
  {
    currency: {
      code: 'USD',
      exchangeBuy: 218.17,
      exchangeSell: 218.17,
      mainCurrency: true
    },
    payments: [
      {
        paymentType: {
          id: 3,
          code: 'DOLLAR_CASH',
          name: 'Depósito de USD',
          photo: null,
          active: true
        },
        banks: [
          {
            bank: {
              id: 26,
              name: 'Banco Nacional de Crédito C.A., Banco Universal',
              code: '0191',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0191-0184-33-2300012688',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE'],
            apiIntegration: true
          },
          {
            bank: {
              id: 1,
              name: 'Banco de Venezuela, S.A. Banco Universal',
              code: '0102',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0102-0497-62-0000835440',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 27,
              name: 'Binance Pay',
              code: 'BP',
              literalCode: '',
              photo: null,
              active: true,
              origin: false
            },
            rif: null,
            accountIdentifier: '229 811 87',
            groupName: null,
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 28,
              name: 'Zelle',
              code: 'ZELLE',
              literalCode: '',
              photo: null,
              active: true,
              origin: false
            },
            rif: null,
            accountIdentifier: 'info@weppa.io',
            groupName: null,
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          }
        ]
      }
    ]
  },
  {
    currency: {
      code: 'BS',
      exchangeBuy: 201.46,
      exchangeSell: 201.46,
      mainCurrency: false
    },
    payments: [
      {
        paymentType: {
          id: 2,
          code: 'TRANSFER_BS',
          name: 'Transferencia o Depósito',
          photo: null,
          active: true
        },
        banks: [
          {
            bank: {
              id: 1,
              name: 'Banco de Venezuela, S.A. Banco Universal',
              code: '0102',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0102-0497-63-0000835123',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE'],
            apiIntegration: true
          },
          {
            bank: {
              id: 26,
              name: 'Banco Nacional de Crédito C.A., Banco Universal',
              code: '0191',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0191-0184-31-2100038506',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE'],
            apiIntegration: true
          },
          {
            bank: {
              id: 20,
              name: 'Bancamiga Banco Universal, C.A.',
              code: '0172',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0172-0110-76-1109894582',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 5,
              name: 'Banco del Caribe C.A., Banco Universal Bancaribe',
              code: '0114',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0114-0194-59-1940020502',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 15,
              name: 'Banco del Tesoro C.A., Banco Universal',
              code: '0163',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0163-0903-61-9033008902',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 6,
              name: 'Banco Exterior C.A., Banco Universal',
              code: '0115',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0115-0010-20-1006253499',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 3,
              name: 'Banco Mercantil C.A., Banco Universal',
              code: '0105',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0105-0699-90-1699226342',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          },
          {
            bank: {
              id: 4,
              name: 'Banco Provincial, S.A. Banco Universal',
              code: '0108',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0108-0027-71-0101235502',
            groupName: 'Weppa Group Investments',
            fields: ['REFERENCE', 'DATE', 'FILE'],
            apiIntegration: false
          }
        ]
      },
      {
        paymentType: {
          id: 1,
          code: 'MOVIL_PAY',
          name: 'Pago Móvil',
          photo: null,
          active: true
        },
        banks: [
          {
            bank: {
              id: 1,
              name: 'Banco de Venezuela, S.A. Banco Universal',
              code: '0102',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0424-2697140',
            groupName: null,
            fields: ['REFERENCE', 'DATE', 'PHONE_NUMBER', 'ORIGIN_BANK'],
            apiIntegration: true
          },
          {
            bank: {
              id: 26,
              name: 'Banco Nacional de Crédito C.A., Banco Universal',
              code: '0191',
              literalCode: '',
              photo: null,
              active: true,
              origin: true
            },
            rif: 'J504865052',
            accountIdentifier: '0424-2697140',
            groupName: null,
            fields: ['REFERENCE', 'DATE', 'PHONE_NUMBER', 'ORIGIN_BANK'],
            apiIntegration: true
          }
        ]
      }
    ]
  }
]
